<template>

    <div class="rule">

        <v-handle />

        <!-- Type -->

        <template v-if="segmenterType === 'segment'">
            <v-select size="sm" :model="type || ''" @input="type = $event">
                <option value="trait">Trait</option>
                <option value="event">Event</option>
                <option value="page">Page</option>
                <option value="charge">Charge</option>
                <option value="product">Product</option>
                <option value="subscription">Subscription</option>
                <option value="tag">Tag</option>
            </v-select>
        </template>

        <!-- Field -->

        <template v-if="segmenterType === 'segment'">
            <v-select size="sm" v-if="type === 'trait'" :model="field || ''" @input="field = $event">
                <option value="">Select Option</option>
                <option v-for="trait in traits" :key="trait.id" :value="trait.field">{{ trait.name }}</option>
            </v-select>
            <v-select size="sm" v-if="type === 'tag'" :model="tagId || ''" @input="tagId = $event">
                <option value="">Select Option</option>
                <option v-for="tag in tags" :key="tag.id" :value="tag.id">{{ tag.name }}</option>
            </v-select>
            <v-select size="sm" v-if="type === 'event'" :model="eventId || ''" @input="eventId = $event">
                <option value="">Select Option</option>
                <option v-for="event in events" :key="event.id" :value="event.id">{{ event.name }}</option>
            </v-select>
        </template>
        <template v-else-if="segmenterType === 'event' && selectedEvent">
            <v-select size="sm" :model="field || ''" @input="field = $event">
                <option value="">Select Option</option>
                <option v-for="p in selectedEvent.properties" :key="p.id" :value="p.name">{{ p.name }}</option>
            </v-select>
        </template>

        <!-- Conditions -->

        <template v-if="type === 'trait' && selectedTrait">
            <v-select v-if="selectedTrait.type === 'string'" size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <option value="is">is</option>
                <option value="is-not">is not</option>
                <option value="contains">contains</option>
                <option value="does-not-contain">does not contain</option>
                <option value="starts-with">starts with</option>
                <option value="ends-with">ends with</option>
                <option value="is-null">is null</option>
                <option value="is-not-null">is not null</option>
                <option value="exists">exists</option>
                <option value="does-not-exist">does not exist</option>
            </v-select>
            <v-select v-else-if="selectedTrait.type === 'number'" size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <option value="is-more-than-number">is greater than</option>
                <option value="is-less-than-number">is less than</option>
                <option value="is-number">is equal to</option>
                <option value="is-not-number">is not equal to</option>
                <option value="is-null">is null</option>
                <option value="is-not-null">is not null</option>
                <option value="exists">exists</option>
                <option value="does-not-exist">does not exist</option>
            </v-select>
            <v-select v-else-if="selectedTrait.type === 'date'" size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <optgroup label="Relative Date">
                    <option value="is-more-than-date">is later than</option>
                    <option value="is-less-than-date">is earlier than</option>
                    <option value="is-next-date">is in the next</option>
                    <option value="is-last-date">is in the last</option>
                    <option value="is-past">is in the past</option>
                    <option value="is-future">is in the future</option>
                </optgroup>
                <optgroup label="Absolute Date">
                    <option value="is-on-date">is on date</option>
                    <option value="is-after-date">is after date</option>
                    <option value="is-before-date">is before date</option>
                </optgroup>
                <optgroup label="Anniversary">
                    <option value="is-this-day">is this day</option>
                    <option value="is-this-month">is this month</option>
                </optgroup>
                <optgroup label="Value">
                    <option value="is-null">is null</option>
                    <option value="is-not-null">is not null</option>
                    <option value="exists">exists</option>
                    <option value="does-not-exist">does not exist</option>
                </optgroup>
            </v-select>
            <v-select v-else-if="selectedTrait.type === 'boolean'" size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <option value="is-true">is true</option>
                <option value="is-false">is false</option>
                <option value="is-null">is null</option>
                <option value="is-not-null">is not null</option>
                <option value="exists">exists</option>
                <option value="does-not-exist">does not exist</option>
            </v-select>
        </template>

        <template v-if="segmenterType === 'segment' && type === 'event' && selectedEvent">
            <v-select size="sm" :model="field" @input="field = $event">
                <option value="">Select Option</option>
                <option value="_id">value</option>
                <option value="count">count</option>
                <option value="first_request_at">first occurred</option>
                <option value="last_request_at">last occurred</option>
            </v-select>
            <v-select v-if="field === '_id'" size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <option value="exists">exists</option>
                <option value="does-not-exist">does not exist</option>
            </v-select>
            <v-select v-if="field === 'count'" size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <option value="is-more-than-number">is greater than</option>
                <option value="is-less-than-number">is less than</option>
                <option value="is-number">is</option>
                <option value="is-not-number">is not</option>
            </v-select>
            <v-select v-else-if="['first_request_at', 'last_request_at'].includes(field)" size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <optgroup label="Relative Date">
                    <option value="is-more-than-date">is later than</option>
                    <option value="is-less-than-date">is earlier than</option>
                    <option value="is-next-date">is in the next</option>
                    <option value="is-last-date">is in the last</option>
                    <option value="is-past">is in the past</option>
                    <option value="is-future">is in the future</option>
                </optgroup>
                <optgroup label="Absolute Date">
                    <option value="is-on-date">is on date</option>
                    <option value="is-after-date">is after date</option>
                    <option value="is-before-date">is before date</option>
                </optgroup>
            </v-select>
        </template>

        <template v-if="segmenterType === 'segment' && type === 'tag' && selectedTag">
            <v-select size="sm" :model="field" @input="field = $event">
                <option value="">Select Option</option>
                <option value="_id">value</option>
                <option value="created_at">created</option>
            </v-select>
            <v-select v-if="field === '_id'" size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <option value="exists">exists</option>
                <option value="does-not-exist">does not exist</option>
            </v-select>
            <v-select v-else-if="field === 'created_at'" size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <optgroup label="Relative Date">
                    <option value="is-more-than-date">is later than</option>
                    <option value="is-less-than-date">is earlier than</option>
                    <option value="is-next-date">is in the next</option>
                    <option value="is-last-date">is in the last</option>
                    <option value="is-past">is in the past</option>
                    <option value="is-future">is in the future</option>
                </optgroup>
                <optgroup label="Absolute Date">
                    <option value="is-on-date">is on date</option>
                    <option value="is-after-date">is after date</option>
                    <option value="is-before-date">is before date</option>
                </optgroup>
            </v-select>
        </template>

        <template v-if="['segment', 'page'].includes(segmenterType) && type === 'page'">
            <v-select size="sm" :model="field" @input="field = $event">
                <option value="">Select Option</option>
                <option value="title">title</option>
                <option value="url.path">path</option>
                <template v-if="segmenterType === 'segment'">
                    <option value="count">count</option>
                    <option value="first_visited_at">first visited</option>
                    <option value="last_visited_at">last visited</option>
                </template>
            </v-select>
            <v-select v-if="['title', 'url.path'].includes(field)" size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <option value="is">is</option>
                <option value="is-not">is not</option>
                <option value="contains">contains</option>
                <option value="does-not-contain">does not contain</option>
                <option value="starts-with">starts with</option>
                <option value="ends-with">ends with</option>
            </v-select>
            <v-select v-if="field === 'count'" size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <option value="is-more-than-number">is greater than</option>
                <option value="is-less-than-number">is less than</option>
                <option value="is-number">is</option>
                <option value="is-not-number">is not</option>
            </v-select>
            <v-select v-else-if="['first_visited_at', 'last_visited_at'].includes(field)" size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <optgroup label="Relative Date">
                    <option value="is-more-than-date">is later than</option>
                    <option value="is-less-than-date">is earlier than</option>
                    <option value="is-next-date">is in the next</option>
                    <option value="is-last-date">is in the last</option>
                    <option value="is-past">is in the past</option>
                    <option value="is-future">is in the future</option>
                </optgroup>
                <optgroup label="Absolute Date">
                    <option value="is-on-date">is on date</option>
                    <option value="is-after-date">is after date</option>
                    <option value="is-before-date">is before date</option>
                </optgroup>
            </v-select>
        </template>

        <template v-if="segmenterType === 'segment' && type === 'product'">
            <v-select size="sm" :model="field" @input="field = $event">
                <option value="">Select Option</option>
                <option value="unique_id">unique id</option>
                <option value="name">name</option>
                <option value="count">count</option>
                <option value="sum">total amount</option>
                <option value="avg">average amount</option>
                <option value="first_purchased_at">first purchased</option>
                <option value="last_purchased_at">last purchased</option>
            </v-select>
            <v-select v-if="['name', 'unique_id'].includes(field)" size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <option value="is">is</option>
                <option value="is-not">is not</option>
                <option value="contains">contains</option>
                <option value="does-not-contain">does not contain</option>
                <option value="starts-with">starts with</option>
                <option value="ends-with">ends with</option>
            </v-select>
            <v-select v-if="['count', 'sum', 'avg'].includes(field)" size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <option value="is-more-than-number">is greater than</option>
                <option value="is-less-than-number">is less than</option>
                <option value="is-number">is</option>
                <option value="is-not-number">is not</option>
            </v-select>
            <v-select v-else-if="['first_purchased_at', 'last_purchased_at'].includes(field)" size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <optgroup label="Relative Date">
                    <option value="is-more-than-date">is later than</option>
                    <option value="is-less-than-date">is earlier than</option>
                    <option value="is-next-date">is in the next</option>
                    <option value="is-last-date">is in the last</option>
                    <option value="is-past">is in the past</option>
                    <option value="is-future">is in the future</option>
                </optgroup>
                <optgroup label="Absolute Date">
                    <option value="is-on-date">is on date</option>
                    <option value="is-after-date">is after date</option>
                    <option value="is-before-date">is before date</option>
                </optgroup>
            </v-select>
        </template>

        <template v-if="segmenterType === 'segment' && type === 'charge'">
            <v-select size="sm" :model="field" @input="field = $event">
                <option value="">Select Option</option>
                <option value="charge_summary.count">count</option>
                <option value="charge_summary.sum">total amount</option>
                <option value="charge_summary.avg">average amount</option>
                <option value="charge_summary.first_charge_at">first charged</option>
                <option value="charge_summary.last_charge_at">last charged</option>
            </v-select>
            <v-select v-if="['charge_summary.count', 'charge_summary.sum', 'charge_summary.avg'].includes(field)" size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <option value="is-more-than-number">is greater than</option>
                <option value="is-less-than-number">is less than</option>
                <option value="is-number">is</option>
                <option value="is-not-number">is not</option>
            </v-select>
            <v-select v-else-if="['charge_summary.first_charge_at', 'charge_summary.last_charge_at'].includes(field)" size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <optgroup label="Relative Date">
                    <option value="is-more-than-date">is later than</option>
                    <option value="is-less-than-date">is earlier than</option>
                    <option value="is-next-date">is in the next</option>
                    <option value="is-last-date">is in the last</option>
                    <option value="is-past">is in the past</option>
                    <option value="is-future">is in the future</option>
                </optgroup>
                <optgroup label="Absolute Date">
                    <option value="is-on-date">is on date</option>
                    <option value="is-after-date">is after date</option>
                    <option value="is-before-date">is before date</option>
                </optgroup>
            </v-select>
        </template>

        <template v-if="segmenterType === 'segment' && type === 'subscription'">
            <v-select size="sm" :model="field" @input="field = $event">
                <option value="">Select Option</option>
                <option value="status">status</option>
                <option value="started_at">start date</option>
                <option value="ended_at">end date</option>
                <option value="trial_started_at">trial start date</option>
                <option value="trial_ended_at">trial end date</option>
                <option value="current_period_start">period start date</option>
                <option value="current_period_end">period end date</option>
                <option value="canceled_at">cancellation date</option>
            </v-select>
            <v-select v-if="field === 'status'" size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <option value="is">is</option>
                <option value="is-not">is not</option>
            </v-select>
            <v-select v-else size="sm" :model="cond" @input="cond = $event">
                <option value="">Select Condition</option>
                <optgroup label="Relative Date">
                    <option value="is-more-than-date">is later than</option>
                    <option value="is-less-than-date">is earlier than</option>
                    <option value="is-next-date">is in the next</option>
                    <option value="is-last-date">is in the last</option>
                    <option value="is-past">is in the past</option>
                    <option value="is-future">is in the future</option>
                </optgroup>
                <optgroup label="Absolute Date">
                    <option value="is-on-date">is on date</option>
                    <option value="is-after-date">is after date</option>
                    <option value="is-before-date">is before date</option>
                </optgroup>
            </v-select>
        </template>

        <!-- Arguments -->

        <template v-if="['is-more-than-date', 'is-less-than-date'].includes(cond)">
            <v-input class="w-100" placeholder="0" :model="arg1" size="sm" @input="arg1 = $event" />
            <v-select :model="arg2" size="sm" @input="arg2 = $event">
                <option value="">Select Unit</option>
                <option value="minutes">minutes ago</option>
                <option value="hours">hours ago</option>
                <option value="days">days ago</option>
                <option value="weeks">weeks ago</option>
                <option value="months">months ago</option>
                <option value="years">years ago</option>
            </v-select>
        </template>

        <template v-if="['is-next-date', 'is-last-date'].includes(cond)">
            <v-input class="w-100" placeholder="0" :model="arg1" size="sm" @input="arg1 = $event" />
            <v-select :model="arg2" size="sm" @input="arg2 = $event">
                <option value="">Select Unit</option>
                <option value="minutes">minutes</option>
                <option value="hours">hours</option>
                <option value="days">days</option>
                <option value="weeks">weeks</option>
                <option value="months">months</option>
                <option value="years">years</option>
            </v-select>
        </template>

        <template v-if="['is-day-of-week'].includes(cond)">
            <v-select :model="arg1" size="sm" @input="arg1 = $event">
                <option value="">Select Day</option>
                <option value="1">Sunday</option>
                <option value="2">Monday</option>
                <option value="3">Tuesday</option>
                <option value="4">Wednesday</option>
                <option value="5">Thursday</option>
                <option value="6">Friday</option>
                <option value="7">Saturday</option>
            </v-select>
        </template>

        <template v-if="['is-day-of-month'].includes(cond)">
            <v-select :model="arg1" size="sm" @input="arg1 = $event">
                <option value="">Select Day</option>
                <option v-for="i in 31" :key="i" :value="i">{{ i }}</option>
            </v-select>
        </template>

        <template v-if="['is-hour'].includes(cond)">
            <v-select :model="arg1" size="sm" @input="arg1 = $event">
                <option value="">Select Hour</option>
                <option v-for="(hour, index) in hours" :key="hour" :value="index">{{ hour }}</option>
            </v-select>
        </template>

        <template v-if="['is-month'].includes(cond)">
            <v-select :model="arg1" size="sm" @input="arg1 = $event">
                <option value="">Select Month</option>
                <option v-for="(month, index) in months" :key="month" :value="index + 1">{{ month }}</option>
            </v-select>
        </template>

        <template v-if="(['is-on-date', 'is-after-date', 'is-before-date']).includes(cond)">
            <v-date-picker class="w-120" size="sm" :model="arg1" @input="arg1 = $event" />
        </template>

        <template v-if="(['is-more-than-number', 'is-less-than-number', 'is-number', 'is-not-number']).includes(cond)">
            <v-input class="w-100" size="sm" :model="arg1" @input="arg1 = $event" />
        </template>

        <template v-if="(['is', 'is-not', 'contains', 'does-not-contain', 'starts-with', 'ends-with']).includes(cond)">
            <template v-if="type === 'subscription' && field === 'status'">
                <v-select :model="arg1" size="sm" @input="arg1 = $event">
                    <option value="">Select Status</option>
                    <option value="active">active</option>
                    <option value="trialing">trialing</option>
                    <option value="past_due">past due</option>
                    <option value="unpaid">unpaid</option>
                    <option value="canceled">canceled</option>
                </v-select>
            </template>
            <v-input v-else class="w-200" size="sm" :model="arg1" @input="arg1 = $event" />
        </template>

        <template v-if="(['is-year']).includes(cond)">
            <v-input class="w-100" size="sm" placeholder="YYYY" maxLength="4" :model="arg1" @input="arg1 = $event" />
        </template>

        <!-- Actions -->

        <a v-if="canRemove" class="action" href="#" @click.prevent="$emit('remove', rule.id)">
            <i class="fas fa-times text-danger"></i>
        </a>

        <a v-if="isLast" class="action" href="#" @click.prevent="$emit('add')">
            <i class="fas fa-plus text-primary"></i>
        </a>

    </div>

</template>

<style scoped lang="scss">

    .rule {
        align-items: center;
        display: flex;
        > * {
            flex-grow: 0;
            margin-right: 5px;
            width: auto;
        }
        > span, > a {
            @include font-medium(13px);
            align-items: center;
            background: $color-bg;
            border: 1px solid $color-rule;
            border-radius: 3px;
            color: $color-text;
            display: flex;
            height: 40px;
            padding: 0 12px;
        }
        .action {
            align-items: center;
            background: #fff;
            border: 1px solid $color-rule;
            border-radius: 3px;
            color: $color-text;
            display: flex;
            font-size: 16px;
            height: 40px;
            justify-content: center;
            padding: 0;
            text-decoration: none;
            transition: .3s border-color;
            width: 40px;
            &:hover {
                border-color: $color-text;
            }
        }
        .remove-button {
            border: 1px solid $color-rule;
            border-radius: 3px;
            display: block;
            height: 40px;
            transition: border-color .3s;
            width: 40px;
            &:hover {
                border-color: $color-text;
            }
        }
    }

</style>

<script>

import moment from 'moment';

export default {

    props: {
        rule: {
            type: Object,
            required: true,
        },
        isFirst: {
            type: Boolean,
            default: false,
        },
        isLast: {
            type: Boolean,
            default: false,
        },
        canRemove: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            type: this.defaultType(),
            eventId: this.rule.event_id ? this.rule.event_id : '',
            tagId: this.rule.tag_id ? this.rule.tag_id : '',
            field: this.defaultField(),
            cond: this.defaultCond(),
            arg1: this.rule.arg1 !== null ? this.rule.arg1 : '',
            arg2: this.rule.arg2 !== null ? this.rule.arg2 : '',
            // For saving...
            oneArgConditions: [
                // String
                'is',
                'is-not',
                'contains',
                'does-not-contain',
                'starts-with',
                'ends-with',
                // Date
                'is-on-date',
                'is-after-date',
                'is-before-date',
                'is-day-of-week',
                'is-day-of-month',
                'is-hour',
                'is-month',
                'is-year',
                // Number
                'is-more-than-number',
                'is-less-than-number',
                'is-number',
                'is-not-number'
            ],
            twoArgConditions: [
                // Date
                'is-more-than-date',
                'is-less-than-date',
                'is-next-date',
                'is-last-date',
            ],
        }
    },

    watch: {

        type(val) {
            this.eventId = '';
            this.tagId = '';
            this.field = '';
            this.cond = '';
            this.arg1 = '';
            this.arg2 = '';
            this.update();
        },

        eventId(val) {
            this.field = '';
            this.cond = '';
            this.arg1 = '';
            this.arg2 = '';
            this.update();
        },

        tagId(val) {
            this.field = '';
            this.cond = '';
            this.arg1 = '';
            this.arg2 = '';
            this.update();
        },

        field(val) {
            this.cond = '';
            this.arg1 = '';
            this.arg2 = '';
            this.update();
        },

        cond(val) {
            this.arg1 = '';
            this.arg2 = '';
            this.update();
        },

        arg1(val) {
            this.update();
        },

        arg2(val) {
            this.update();
        },

    },

    computed: {

        segmenterType() {
            return this.$store.getters['segmenter/type'];
        },

        segmenterModel() {
            return this.$store.getters['segmenter/model'];
        },

        traits() {
            return this.project.traits
                .filter(trait => {
                    if (trait.visibility.segment) {
                        return trait;
                    }
                })
                .sort((a, b) => {
                    if (a.name < b.name) { return -1; }
                    if (a.name > b.name) { return 1; }
                    return 0;
                });
        },

        events() {
            return this.project.events;
        },

        tags() {
            return this.project.tags;
        },

        selectedTrait() {
            if (this.segmenterType === 'event') {
                return this.selectedEvent?.properties.find(p => p.name === this.field);
            } else if (this.type === 'trait') {
                return this.traits.find(i => i.field === this.field);
            } else if (this.type === 'tag') {
                return this.tags.find(i => i.id === this.field);
            }
            return null;
        },

        selectedEvent() {
            if (this.segmenterType === 'event') {
                return this.events.find(i => i.id === this.segmenterModel?.event_id);
            } else if (this.type === 'event') {
                return this.events.find(i => i.id === this.eventId);
            }
            return null;
        },

        selectedTag() {
            if (this.type === 'tag') {
                return this.tags.find(i => i.id === this.tagId);
            }
            return null;
        },

        months() {
            return moment.months();
        },

        hours() {
            let hours = [];
            for (let i = 0; i < 24; i++) {
                if (i === 0) {
                    hours.push('12:00 AM');
                } else if (i >= 1 && i <= 11) {
                    hours.push(`${i}:00 AM`);
                } else if (i === 12) {
                    hours.push(`12:00 PM`);
                } else if (i >= 13) {
                    hours.push(`${i - 12}:00 PM`);
                }
            }
            return hours;
        },

    },

    methods: {

        defaultType() {
            let segmenterType = this.$store.getters['segmenter/type'];
            let type = this.rule.type;
            if (!type && segmenterType === 'page') type = 'page';
            return type || 'trait';
        },

        defaultField() {
            let segmenterType = this.$store.getters['segmenter/type'];
            let field = this.rule.field;
            if (!field && segmenterType === 'page') field = 'url.path';
            return field || '';
        },

        defaultCond() {
            let segmenterType = this.$store.getters['segmenter/type'];
            let cond = this.rule.cond;
            if (!cond && segmenterType === 'page') cond = 'starts-with';
            return cond || '';
        },

        update() {
            let params = {
                id: this.rule.id,
                type: this.type,
                event_id: this.eventId,
                tag_id: this.tagId,
                field: this.field,
                cond: this.cond,
            }
            if ((this.oneArgConditions).includes(this.cond)) {
                params.arg1 = this.arg1;
            } else if ((this.twoArgConditions).includes(this.cond)) {
                params.arg1 = this.arg1;
                params.arg2 = this.arg2;
            }
            this.$store.commit('segmenter/updateRule', params);
        },

    },

}

</script>
